export const marketingPageSections = {
    benefits: 'benefits',
    benefitsRewards: 'benefitsRewards',
    dynamicRedirection: 'dynamicRedirection',
    dynamicRedirectionBanner: 'dynamicRedirectionBanner',
    dynamicRedirectionFooter: 'dynamicRedirectionFooter',
    heroSection: 'heroSection',
    howItWorks: 'howItWorks',
    loyaltyConfig: 'loyaltyConfig',
    pointBenefit: 'pointBenefit',
    tierBenefit: 'tierBenefit',
    tierBenefits: 'tierBenefits',
    earnPoints: 'earnPoints'
};
